export default __webpack_public_path__ + "img/sg_mixer-11fab80aafcf008d7f4c62d91313b37d.png";